import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    data: Object,
  };

  connect() {
    // Check if we have data from backend
    if (this.dataValue && this.dataValue.datasets && this.dataValue.labels) {
      let chartStatus = Chart.getChart('abilitiesChart');
      if (chartStatus != undefined) {
        chartStatus.destroy();
      }

      // Get data from backend in the new format
      const chartData = this.dataValue;

      // Convert decimal data to percentage for display
      const dataset = chartData.datasets[0];
      const percentageData = dataset.data.map((value) => value * 100);

      let ctx = document.getElementById('abilitiesChart').getContext('2d');
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: chartData.labels,
          datasets: [
            {
              label: dataset.label || 'Acertos por questão',
              data: percentageData,
              backgroundColor: dataset.backgroundColor,
              borderColor: dataset.borderColor,
              borderWidth: dataset.borderWidth || 1,
              borderRadius: 8,
              barThickness: dataset.barThickness || 25,
              categoryPercentage: dataset.categoryPercentage || 0.1,
              barPercentage: dataset.barPercentage || 1.0,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 20,
              bottom: 20,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              titleColor: '#000000',
              bodyColor: '#666666',
              borderColor: '#E5E5E5',
              borderWidth: 1,
              cornerRadius: 8,
              padding: 12,
              displayColors: false,
              callbacks: {
                label: function (context) {
                  return `Desempenho: ${context.parsed.y.toFixed(1)}%`;
                },
              },
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
              ticks: {
                font: {
                  size: 11,
                },
                autoSkip: false,
                maxRotation: 45,
                minRotation: 45,
              },
            },
            y: {
              min: 0,
              max: 100,
              ticks: {
                stepSize: 20,
                font: {
                  size: 12,
                },
                callback: function (value) {
                  return value + '%';
                },
              },
              grid: {
                color: '#F0F0F0',
              },
            },
          },
        },
      });
    }
  }
}
